export const dueDilligenceTabInfoSelector = (state) =>
  state.dueDilligenceTab.dueDilligenceInfo;
export const dueDilligenceTabLoadingSelector = (state) =>
  state.dueDilligenceTab.isLoadingDueDilligence;
export const dueDilligenceTabErrorSelector = (state) =>
  state.dueDilligenceTab.dueDilligenceError;
